import React, { useState, useEffect } from 'react';
import Button from '../Button/Button';
import SearchBar from '../SearchBar/SearchBar'; // NOUVEAU: Import du composant SearchBar
import ArticlesService, { Article } from '../../services/articlesService';
import { formatPrixByLot, calculateTotalHT, formatPrice } from '../../utils/priceUtils';
import './ModalArticles.css';

/**
 * Formater un prix en fonction de l'unité et du lot technique
 * - Pour lot 105 avec unité "€ (Budget)" : 4 décimales
 * - Sinon : 2 décimales
 * @deprecated Utiliser formatPrixByLot de priceUtils.tsx à la place
 */
const formatPrix = (prix: number, unite?: string, idLotTechnique?: number, withCurrency: boolean = true): string => {
  return formatPrixByLot(prix, unite, idLotTechnique, withCurrency);
};

interface ModalArticlesProps {
  isOpen: boolean;
  onClose: () => void;
  commandes: any[];
  lotNom: string;
  onAddToCommand: (articles: Article[]) => void;
  existingSelection?: Article[];
  prestataireRang: number;
}

const ModalArticles: React.FC<ModalArticlesProps> = ({
  isOpen,
  onClose,
  commandes,
  lotNom,
  onAddToCommand,
  existingSelection = [],
  prestataireRang
}) => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [filteredArticles, setFilteredArticles] = useState<Article[]>([]); // NOUVEAU: Articles filtrés
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [expandedArticle, setExpandedArticle] = useState<string | null>(null);
  const [articleDetails, setArticleDetails] = useState<{ [key: string]: Article }>({});
  const [error, setError] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState(''); // NOUVEAU: Terme de recherche
  // const [searchLoading, setSearchLoading] = useState(false); // NOUVEAU: État de chargement de recherche

  // MODIFIÉ: Fonction pour filtrer en front-end
const filterArticlesLocally = (searchTerm: string) => {
  if (!searchTerm.trim()) {
    // Si pas de terme de recherche, afficher tous les articles
    setFilteredArticles(articles);
    return;
  }

  // Normaliser le terme de recherche (minuscules, sans accents)
  const normalizeString = (str: string) => {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  const searchTerms = normalizeString(searchTerm).split(' ').filter(term => term.length > 0);

  // Filtrer les articles
  const filtered = articles.filter(article => {
    const searchableText = normalizeString(
      `${article.code} ${article.nom} ${article.description}`
    );

    // Vérifier que tous les termes de recherche sont présents
    return searchTerms.every(term => searchableText.includes(term));
  });

  setFilteredArticles(filtered);
};

// MODIFIÉ: useEffect pour filtrage en temps réel (sans debounce nécessaire car pas d'API)
useEffect(() => {
    filterArticlesLocally(searchTerm);
}, [searchTerm, articles]);

// MODIFIÉ: Fonction pour gérer le changement de terme de recherche
const handleSearch = (value: string) => {
  setSearchTerm(value);
};

// Fonction pour effacer la recherche
const handleClearSearch = () => {
  setSearchTerm('');
  setFilteredArticles(articles);
};

  // NOUVEAU: Fonction pour rechercher dans l'API
  // const searchArticles = async (searchTerm: string) => {
  //   if (!searchTerm.trim()) {
  //     // Si pas de terme de recherche, afficher tous les articles
  //     setFilteredArticles(articles);
  //     return;
  //   }

  //   setSearchLoading(true);
  //   try {
  //     const token = localStorage.getItem('token');
  //     if (!token) {
  //       throw new Error('Token d\'authentification manquant');
  //     }

  //     console.log('Recherche d\'articles avec le terme:', searchTerm);

  //     // CORRECTION: Extraire les IDs de contrat depuis les commandes
  //     const ids = commandes.map(cmd => {
  //       if (cmd.id_contrat) {
  //         return cmd.id_contrat;
  //       }
  //       if (cmd.contrat?.id) {
  //         return cmd.contrat.id;
  //       }
  //       if (cmd.operation && commandes.length === 1) {
  //         const operationCommandes = cmd.operation.commandes || [];
  //         return operationCommandes.map((opCmd: any) => opCmd.id_contrat).filter(Boolean);
  //       }
  //       return null;
  //     }).flat().filter(Boolean);

  //     const idsString = Array.from(new Set(ids)).join(',');
  //     console.log('IDs de contrats pour la recherche:', idsString);

  //     // CORRECTION: Construire l'URL avec les deux paramètres
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/bdc/catalogue/prix?catalogue_prix_id_lot_contrat=${idsString}&catalogue_nom=${encodeURIComponent(searchTerm)}`,
  //       {
  //         headers: {
  //           'Authorization': `Bearer ${token}`,
  //           'Content-Type': 'application/json',
  //           'Accept': 'application/json'
  //         }
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`Erreur HTTP: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     console.log('Résultats de recherche:', data);

  //     if (data.status === 'success' && data.data && data.data.data) {
  //       // CORRECTION: Formater les résultats selon la nouvelle structure avec pagination
  //       const searchResults: Article[] = data.data.data.map((item: any) => {
  //         // Utiliser la première commande pour les informations de contexte
  //         const firstCommande = commandes[0];
  //         let departementId = '00';
  //         let lotTechniqueId = '000';

  //         if (firstCommande) {
  //           // CORRECTION: Extraire le département avec la même logique que articlesService
  //           if (firstCommande.operation?.lot_departement?.departement?.id) {
  //             departementId = firstCommande.operation.lot_departement.departement.id.toString().padStart(2, '0');
  //           } else if (firstCommande.lot_departement?.departement?.id) {
  //             departementId = firstCommande.lot_departement.departement.id.toString().padStart(2, '0');
  //           } else if (firstCommande.operation?.id_lot_departement) {
  //             departementId = firstCommande.operation.id_lot_departement.toString().padStart(2, '0');
  //           } else if (firstCommande.id_lot_departement) {
  //             departementId = firstCommande.id_lot_departement.toString().padStart(2, '0');
  //           }

  //           // CORRECTION: Prioriser l'id_lot_technique de l'article, puis celui de l'opération
  //           if (item.id_lot_technique) {
  //             lotTechniqueId = item.id_lot_technique.toString();
  //           } else if (firstCommande.operation?.id_lot_technique) {
  //             lotTechniqueId = firstCommande.operation.id_lot_technique.toString();
  //           } else if (firstCommande.id_lot_technique) {
  //             lotTechniqueId = firstCommande.id_lot_technique.toString();
  //           } else if (firstCommande.operation?.lot_technique?.id) {
  //             lotTechniqueId = firstCommande.operation.lot_technique.id.toString();
  //           } else if (firstCommande.contrat?.lot_technique?.id) {
  //             lotTechniqueId = firstCommande.contrat.lot_technique.id.toString();
  //           } else if (firstCommande.lot_technique?.id) {
  //             lotTechniqueId = firstCommande.lot_technique.id.toString();
  //           }
  //         }

  //         // Générer la référence
  //         const reference = `${departementId} ${lotTechniqueId} ${item.code || ''} ${prestataireRang}`;

  //         // CORRECTION: Trouver le prix correspondant au rang du prestataire
  //         const prixData = item.prix ?
  //           item.prix.find((prix: any) => parseInt(prix.rang) === prestataireRang) || item.prix[0]
  //           : null;

  //         return {
  //           id: item.id?.toString() || '',
  //           code: reference,
  //           nom: item.nom || '',
  //           description: item.description || '',
  //           prix: prixData ? parseFloat(prixData.prix_a) || 0 : 0,
  //           unite: item.unite || 'Unité',
  //           id_lot_technique: item.id_lot_technique, // ✅ Conserver id_lot_technique pour formatage des prix
  //           quantite: 0,
  //           totalHT: 0,
  //           // CORRECTION: Calculer les prix dégressifs avec la nouvelle structure
  //           prixDegressifs: prixData ? {
  //             palier1: {
  //               min: 1,
  //               max: item.seuil_a || 5,
  //               prix: parseFloat(prixData.prix_a) || 0
  //             },
  //             palier2: {
  //               min: (item.seuil_a || 5) + 1,
  //               max: item.seuil_b || 10,
  //               prix: parseFloat(prixData.prix_b) || 0
  //             },
  //             palier3: {
  //               min: (item.seuil_b || 10) + 1,
  //               prix: parseFloat(prixData.prix_c) || 0
  //             }
  //           } : undefined
  //         };
  //       });

  //       // Restaurer les quantités existantes pour les articles trouvés
  //       const searchResultsWithQuantities = searchResults.map(article => {
  //         const existing = existingSelection.find(existing =>
  //           existing.id === article.id ||
  //           existing.catalogueId === article.id ||
  //           existing.code === article.code
  //         );

  //         if (existing) {
  //           return {
  //             ...article,
  //             quantite: existing.quantite || 0,
  //             totalHT: existing.totalHT || 0
  //           };
  //         }
  //         return article;
  //       });

  //       console.log('Articles de recherche formatés:', searchResultsWithQuantities);
  //       setFilteredArticles(searchResultsWithQuantities);
  //     } else {
  //       setFilteredArticles([]);
  //     }
  //   } catch (error) {
  //     console.error('Erreur lors de la recherche:', error);
  //     setError('Erreur lors de la recherche des articles');
  //     setFilteredArticles([]);
  //   } finally {
  //     setSearchLoading(false);
  //   }
  // };

  // // NOUVEAU: Gestionnaire de recherche avec debounce
  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     searchArticles(searchTerm);
  //   }, 500); // Debounce de 500ms

  //   return () => clearTimeout(timeoutId);
  // }, [searchTerm, articles, existingSelection]);

  // REMPLACER le useEffect existant (lignes 160-214) par celui-ci :
  useEffect(() => {
    const loadCatalogueArticles = async () => {
      if (!isOpen || commandes.length === 0) return;

      // NOUVEAU: Réinitialiser la recherche lors de l'ouverture du modal
      setSearchTerm('');
      setLoading(true);
      setError(null);

      try {
        console.log('=== CHARGEMENT CATALOGUE ===');
        console.log('Commandes reçues:', commandes);
        console.log('Premier commande:', commandes[0]);
        console.log('URL actuelle:', window.location.pathname);

        // CORRECTION: Vérifier si c'est un contexte BC via plusieurs indicateurs
        const isBC = (() => {
          // 1. Vérifier le marqueur prestataire
          const hasPrestataireMark = commandes.some(cmd => cmd._isPrestataireContext === true);
          if (hasPrestataireMark) return true;

          // 2. Vérifier si c'est dans le contexte d'une opération transférée
          const hasTransferredOp = commandes.some(cmd => cmd.operation?.transferred === true);
          if (hasTransferredOp) return true;

          // 3. Vérifier si l'URL contient 'bon-commande' (pour les prestataires ET acheteurs BC)
          const urlContainsBonCommande = window.location.pathname.includes('bon-commande');
          if (urlContainsBonCommande) return true;

          // 4. Vérifier si les commandes ont la structure BC
          const hasBCStructure = commandes.some(cmd => cmd.id_contrat !== undefined);
          if (hasBCStructure) return true;

          return false;
        })();

        console.log('Context BC détecté:', isBC);

        if (isBC) {
          console.log('=== UTILISATION API BC ===');
          // CORRECTION: Utiliser l'API BC avec la même logique que pour les acheteurs
          const articlesData = await ArticlesService.getArticlesByCommandes(commandes);
          console.log('Articles BC reçus:', articlesData);

          const articlesWithCorrectPrices = articlesData.map(article => {
            return {
              ...article,
              quantite: 0,
              totalHT: 0
            };
          });

          // Restaurer les quantités existantes avec un matching plus robuste
          const articlesWithQuantities = articlesWithCorrectPrices.map(article => {
            const existing = existingSelection.find(existing =>
              existing.id === article.id ||
              existing.catalogueId === article.id ||
              existing.code === article.code
            );

            if (existing) {
              console.log('Article trouvé dans la sélection existante:', article.nom, 'avec quantité:', existing.quantite);
              return {
                ...article,
                quantite: existing.quantite || 0,
                totalHT: existing.totalHT || 0
              };
            }
            return article;
          });

          console.log('Articles avec quantités restaurées:', articlesWithQuantities);
          setArticles(articlesWithQuantities);
          setFilteredArticles(articlesWithQuantities);

        } else {
          console.log('=== UTILISATION API MS ===');
          // Pour les MS, utiliser l'ancienne logique
          const firstCommande = commandes[0];
          const lotIds = [firstCommande.id_contrat || firstCommande.contrat?.id].filter(id => id);

          if (lotIds.length > 0) {
            const articlesData = await ArticlesService.getArticlesByLot(lotIds);

            const articlesWithCorrectPrices = articlesData.map(article => {
              return {
                ...article,
                quantite: 0,
                totalHT: 0
              };
            });

            // Restaurer les quantités existantes
            const articlesWithQuantities = articlesWithCorrectPrices.map(article => {
              const existing = existingSelection.find(existing =>
                existing.id === article.id ||
                existing.catalogueId === article.id ||
                existing.code === article.code
              );

              if (existing) {
                return {
                  ...article,
                  quantite: existing.quantite || 0,
                  totalHT: existing.totalHT || 0
                };
              }
              return article;
            });

            setArticles(articlesWithQuantities);
            setFilteredArticles(articlesWithQuantities);
          }
        }
      } catch (error) {
        console.error('Erreur lors du chargement des articles:', error);
        setError(error instanceof Error ? error.message : 'Erreur lors du chargement des articles');
      } finally {
        setLoading(false);
      }
    };

    loadCatalogueArticles();
  }, [isOpen, commandes, existingSelection, prestataireRang]);

  // Fonction pour gérer le changement de quantité
  const handleQuantityChange = (articleId: string, newQuantity: number) => {
    const quantity = Math.max(0, newQuantity);

    // Mettre à jour les deux états séparément
    setArticles(prevArticles => 
      prevArticles.map(article => {
        if (article.id === articleId) {
          const prixUnitaire = ArticlesService.getPrixByQuantity(article, quantity);
          // ✅ Utiliser la fonction utilitaire pour garantir la précision à 4 décimales
          const totalHT = calculateTotalHT(prixUnitaire, quantity);
          return {
            ...article,
            quantite: quantity,
            totalHT
          };
        }
        return article;
      })
    );

    setFilteredArticles(prevFiltered =>
      prevFiltered.map(article => {
        if (article.id === articleId) {
          const prixUnitaire = ArticlesService.getPrixByQuantity(article, quantity);
          const totalHT = calculateTotalHT(prixUnitaire, quantity);
          return {
            ...article,
            quantite: quantity,
            totalHT
          };
        }
        return article;
      })
    );
  };

  // Fonction pour diminuer la quantité
  const decreaseQuantity = (articleId: string) => {
    const article = filteredArticles.find(a => a.id === articleId);
    if (article && article.quantite > 0) {
      handleQuantityChange(articleId, article.quantite - 1);
    }
  };

  // Fonction pour augmenter la quantité
  const increaseQuantity = (articleId: string) => {
    const article = filteredArticles.find(a => a.id === articleId);
    if (article) {
      handleQuantityChange(articleId, article.quantite + 1);
    }
  };

  // Fonction pour afficher/masquer les détails
  const toggleDetails = async (articleId: string) => {
    if (expandedArticle === articleId) {
      setExpandedArticle(null);
      return;
    }

    setExpandedArticle(articleId);

    // if (!articleDetails[articleId]) {
    //   try {
    //     const details = await ArticlesService.getArticleDetails(articleId);
    //     if (details) {
    //       setArticleDetails(prev => ({
    //         ...prev,
    //         [articleId]: details
    //       }));
    //     }
    //   } catch (error) {
    //     console.error('Erreur lors du chargement des détails:', error);
    //   }
    // }
  };

  // MODIFIÉ: Fonction pour sauvegarder les articles en BDD avec détection du contexte
  const saveArticlesToDatabase = async (selectedArticles: Article[]) => {
    try {
      // NOUVEAU: Déterminer si c'est un prestataire ou un acheteur
      const isPrestataire = (() => {
        // 1. Vérifier si on a le marqueur prestataire dans les commandes
        const hasPrestataireMark = commandes.some(cmd => cmd._isPrestataireContext === true);
        if (hasPrestataireMark) {
          console.log('Contexte prestataire détecté via marqueur _isPrestataireContext');
          return true;
        }

        // 2. Vérifier l'URL - si elle contient 'bon-commande' ET que ce n'est pas dans /operation-ms/
        const urlContainsBonCommande = window.location.pathname.includes('bon-commande');
        const urlNotInOperations = !window.location.pathname.includes('operations');
        if (urlContainsBonCommande && urlNotInOperations) {
          console.log('Contexte prestataire détecté via URL bon-commande');
          return true;
        }

        // 3. Vérifier si les données de commande indiquent un prestataire transféré
        const hasTransferredOperation = commandes.some(cmd => cmd.operation?.transferred === true);
        if (hasTransferredOperation) {
          console.log('Contexte prestataire détecté via opération transférée');
          return true;
        }

        console.log('Contexte acheteur détecté (défaut)');
        return false;
      })();

      console.log('=== Sauvegarde articles ===');
      console.log('Context prestataire détecté:', isPrestataire);
      console.log('URL actuelle:', window.location.pathname);
      console.log('Commandes:', commandes);

      // CORRECTION: Extraire l'ID selon le contexte
      let entityId;
      if (isPrestataire) {
        // Pour les prestataires, utiliser l'ID de la commande
        // 1. Essayer depuis l'URL bon-commande
        const pathParts = window.location.pathname.split('/');
        const bonCommandeIndex = pathParts.indexOf('bon-commande');
        if (bonCommandeIndex !== -1 && pathParts[bonCommandeIndex + 1]) {
          entityId = pathParts[bonCommandeIndex + 1];
        }
        // 2. Fallback: utiliser l'ID depuis les données de commande
        if (!entityId && commandes[0]) {
          entityId = commandes[0].id;
        }
        console.log('ID commande prestataire:', entityId);
      } else {
        // Pour les acheteurs, utiliser l'ID de l'opération depuis l'URL
        const pathParts = window.location.pathname.split('/');
        if (pathParts.includes('operations')) {
          const operationsIndex = pathParts.indexOf('operations');
          entityId = pathParts[operationsIndex + 1];
        } else {
          // Fallback: essayer de récupérer depuis les commandes
          entityId = commandes[0]?.operation?.id || commandes[0]?.id_operation;
        }
        console.log('ID opération acheteur:', entityId);
      }

      if (!entityId) {
        throw new Error('ID de l\'entité non trouvé');
      }

      // Préparer le payload selon le format attendu par l'API
      const payload = {
        articles: selectedArticles.map(article => ({
          // id_catalogue: Number(article?.prix?.id), // <-- important : bigint / number
          id_catalogue: Number(article.id),
          quantity: article.quantite
        }))
      };

      console.log('Payload envoyé à l\'API:', payload);

      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token d\'authentification non trouvé');
      }

      // CORRECTION: Utiliser l'endpoint approprié selon le contexte
      const endpoint = isPrestataire
        ? `/bdc/commande/${entityId}/catalogue`
        : `/bdc/operation/${entityId}/catalogue`;

      console.log('Endpoint utilisé:', endpoint);
      console.log('URL complète:', `${process.env.REACT_APP_API_URL}${endpoint}`);

      const response = await fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Erreur HTTP: ${response.status}`);
      }

      const result = await response.json();
      console.log('Réponse de l\'API:', result);

      return result;
    } catch (error) {
      console.error('Erreur lors de la sauvegarde des articles:', error);
      throw error;
    }
  };

  // MODIFIÉ: Fonction pour ajouter à la commande avec sauvegarde en BDD
  const handleAddToCommand = async () => {
    // ✅ CORRECTION: Utiliser `articles` au lieu de `filteredArticles` pour avoir TOUS les articles sélectionnés
    const selectedArticles = articles.filter(article => article.quantite > 0);

    if (selectedArticles.length === 0) {
      alert('Veuillez sélectionner au moins un article.');
      return;
    }

    setSaving(true);
    setError(null);

    try {
      await saveArticlesToDatabase(selectedArticles);
      onAddToCommand(selectedArticles);
      onClose();
    } catch (error) {
      console.error('Erreur lors de l\'ajout des articles:', error);
      setError(error instanceof Error ? error.message : 'Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  // Calculer le total avec arrondi à 4 décimales
  // ✅ CORRECTION: Utiliser `articles` au lieu de `filteredArticles` pour compter TOUS les articles sélectionnés
  const totalSelection = parseFloat(
    articles
      .filter(article => article.quantite > 0)
      .reduce((sum, article) => sum + article.totalHT, 0)
      .toFixed(4)
  );

  const selectedCount = articles.filter(article => article.quantite > 0).length;

  // Fonction pour déterminer si un article est ajouté à la commande
  const isArticleAdded = (article: Article) => article.quantite > 0;

  if (!isOpen) return null;

  return (
    <div className="modal-articles-overlay">
      <div className="modal-articles">
        <div className="modal-articles-header">
          <h2>Catalogue - {lotNom}</h2>
          <button className="close-button" onClick={onClose} disabled={saving}>×</button>
        </div>

        {/* NOUVEAU: Barre de recherche */}
        <div className="modal-articles-search">
          <SearchBar
            placeholder="Rechercher une prestation..."
            value={searchTerm}
            onChange={handleSearch}
            onClear={handleClearSearch}
            loading={false}
          />
          {searchTerm && (
            <div className="search-info">
              <span>
                {filteredArticles.length} résultat{filteredArticles.length !== 1 ? 's' : ''}
                {searchTerm && ` pour "${searchTerm}"`}
              </span>
            </div>
          )}
        </div>

        <div className="modal-articles-content">
          {loading ? (
            <div className="loading-state">
              <div className="loading-spinner"></div>
              <p>Chargement du catalogue...</p>
            </div>
          ) : error ? (
            <div className="error-state">
              <p>{error}</p>
              <Button
                value="Réessayer"
                variant="primary"
                size="small"
                onClick={() => {
                  setError(null);
                  const loadArticles = async () => {
                    setLoading(true);
                    try {
                      const articlesData = await ArticlesService.getArticlesByCommandes(commandes);
                      setArticles(articlesData);
                      setFilteredArticles(articlesData);
                    } catch (err) {
                      console.error(err);
                      setError('Impossible de charger les articles du catalogue.');
                    } finally {
                      setLoading(false);
                    }
                  };
                  loadArticles();
                }}
              />
            </div>
          ) : (
            <div className="articles-list">
              {filteredArticles.length === 0 ? (
                <div className="error-state">
                  <p>
                    {searchTerm ?
                      `Aucun article trouvé pour "${searchTerm}"` :
                      'Aucun article disponible pour ce catalogue.'
                    }
                  </p>
                  {searchTerm && (
                    <Button
                      value="Effacer la recherche"
                      variant="secondary"
                      size="small"
                      onClick={handleClearSearch}
                    />
                  )}
                </div>
              ) : (
                filteredArticles.map((article) => (
                  <div key={article.id} className="article-container">
                    <div className={`article-row ${isArticleAdded(article) ? 'article-added' : ''}`}>
                      {/* Code article */}
                      <div className="article-code">
                        {article.code}
                      </div>

                      {/* Informations article */}
                      <div className="article-info">
                        <h4 className="article-nom">{article.nom}</h4>
                        <p className="article-prix">
                          {article.quantite >= 1 ? (
                            <>
                              <span className="prix-value">
                                {formatPrixByLot(ArticlesService.getPrixByQuantity(article, article.quantite), article.unite, article.id_lot_technique, false)} €
                              </span> / {article.unite}
                            </>
                          ) : (
                            <span className="prix-placeholder">
                              Prix affiché après sélection / {article.unite}
                            </span>
                          )}
                        </p>
                      </div>

                      {/* Contrôles de quantité */}
                      <div className="quantity-controls">
                        <button
                          className="quantity-btn decrease"
                          onClick={() => decreaseQuantity(article.id)}
                          disabled={article.quantite <= 0 || saving}
                        >
                          −
                        </button>
                        <input
                          type="number"
                          className="quantity-input"
                          min="0"
                          value={article.quantite}
                          onChange={(e) => handleQuantityChange(article.id, parseInt(e.target.value) || 0)}
                          disabled={saving}
                        />
                        <button
                          className="quantity-btn increase"
                          onClick={() => increaseQuantity(article.id)}
                          disabled={saving}
                        >
                          +
                        </button>
                      </div>

                      {/* Total affiché seulement si quantité > 0 */}
                      <div className="article-total">
                        <div className="total-value">
                          {article.quantite > 0 ? formatPrix(article.totalHT, article.unite, article.id_lot_technique) : ''}
                        </div>
                      </div>

                      {/* Bouton détails */}
                      <div>
                        <Button
                          value={expandedArticle === article.id ? 'Masquer' : 'Détails'}
                          variant="secondary"
                          size="small"
                          onClick={() => toggleDetails(article.id)}
                          disabled={saving}
                        />
                      </div>
                    </div>

                    {/* Section des détails expandable */}
                    {expandedArticle === article.id && (
                      <div className="article-details-expanded">
                        <div className="details-header">
                          <h5>Détails de l'article</h5>
                        </div>

                        <div className="details-description">
                          <p>{article.description}</p>
                        </div>

                        {articleDetails[article.id]?.detailsComplets && (
                          <div className="details-description">
                            <h6>Informations détaillées</h6>
                            <p>{articleDetails[article.id].detailsComplets?.descriptionLongue}</p>
                          </div>
                        )}

                        {article.prixDegressifs && (
                          <div className="prix-degressifs">
                            <h6>Prix dégressifs</h6>
                            <div className="prix-table">
                              <table>
                                <thead>
                                  <tr>
                                    <th>Quantité</th>
                                    <th>Prix unitaire</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{ArticlesService.formatPalierLabel(article.prixDegressifs.palier1)}</td>
                                    <td>{formatPrix(article.prixDegressifs.palier1.prix, article.unite, article.id_lot_technique)}</td>
                                  </tr>
                                  <tr>
                                    <td>{ArticlesService.formatPalierLabel(article.prixDegressifs.palier2)}</td>
                                    <td>{formatPrix(article.prixDegressifs.palier2.prix, article.unite, article.id_lot_technique)}</td>
                                  </tr>
                                  <tr>
                                    <td>{ArticlesService.formatPalierLabel(article.prixDegressifs.palier3)}</td>
                                    <td>{formatPrix(article.prixDegressifs.palier3.prix, article.unite, article.id_lot_technique)}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        <div className="modal-articles-footer">
          <div className="footer-summary">
            <div className="selected-count">
              {selectedCount} article{selectedCount > 1 ? 's' : ''} sélectionné{selectedCount > 1 ? 's' : ''}
            </div>
            <div className="footer-total">
              Total HT (Rang {prestataireRang}): <span className="total-amount">
                {/* Utiliser formatPrice pour affichage intelligent (2 ou 4 décimales) */}
                {formatPrice(totalSelection)}
              </span>
            </div>
          </div>

          <div className="footer-actions">
            <Button
              value="Annuler"
              variant="secondary"
              onClick={onClose}
              disabled={saving}
            />
            <Button
              value={saving ? 'Sauvegarde...' : `Ajouter ${selectedCount > 0 ? `(${selectedCount})` : ''}`}
              variant="primary"
              onClick={handleAddToCommand}
              disabled={selectedCount === 0 || saving}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalArticles;